module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_troendelag_pos.b87e0e50.pdf";